import { render } from "./Assignusertobusiness.vue?vue&type=template&id=00fc0c77"
import script from "./Assignusertobusiness.vue?vue&type=script&lang=js"
export * from "./Assignusertobusiness.vue?vue&type=script&lang=js"

import "./Assignusertobusiness.vue?vue&type=style&index=0&id=00fc0c77&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__